import { compose } from '@beef/redux';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { selectContentEmptyText, selectContentErrorText, selectError, selectIsEmptyResponse } from "../../../../store/slices/search/selectors";
import { StatusScreen } from "./StatusScreen";
export var Empty = compose(connect(function (state) {
  return {
    text: selectContentEmptyText(state),
    shouldRender: selectIsEmptyResponse(state)
  };
}), withRenderFlag)(StatusScreen);
export var Error = compose(connect(function (state) {
  return {
    text: selectContentErrorText(state),
    shouldRender: !!selectError(state).message
  };
}), withRenderFlag)(StatusScreen);